module.exports = {"120116001":"塘沽街道","120116005":"杭州道街道","120116006":"新河街道","120116007":"大沽街道","120116008":"新北街道","120116009":"北塘街道","120116011":"胡家园街道","120116012":"新港街道","120116013":"新村街道","120116014":"天津经济技术开发区东区泰达街道","120116031":"汉沽街道","120116032":"寨上街道","120116033":"茶淀街道","120116051":"大港街道","120116053":"古林街道","120116054":"海滨街道","120116100":"新城镇","120116135":"杨家泊镇","120116156":"太平镇","120116157":"小王庄镇","120116158":"中塘镇","120116400":"天津经济技术开发区（其他片区）","120116401":"天津港保税区","120116402":"天津滨海新区高新技术产业开发区","120116403":"东疆保税港区","120116406":"中新天津生态城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120116.json
// module id = 137
// module chunks = 0